import { Fragment } from "react";
import style from "./insurance_ease.module.css";
import Button from "@/components/UI/button/button";
import Image from "next/image";
import Carousel from "react-elastic-carousel";
import { useRouter } from "next/router";
import DropLeadModal from "@/components/common/droplead-modal/droplead_modal";
import { useState } from "react";

export default function InsuranceEase() {
  const router = useRouter()
  const [isOpenDropLeadModal, setIsOpenDropLeadModal] = useState();
  const onClickHandler = () => {
    router.push("/calculate-plan/home-info");
  };
  const onDropLeadModalOpenHandler = () => {
    setIsOpenDropLeadModal(true)
  }
  
  const easeIcons = [
    {
      id: 1,
      imageUrl: "/assets/icon-png/overall-ease.png",
      title: "แผนประกันภัยที่ครอบคลุมทุกความต้องการ",
    },
    {
      id: 2,
      imageUrl: "/assets/icon-png/installment.png",
      title: "จ่ายสะดวกได้หลายช่องทาง",
    },
    {
      id: 3,
      imageUrl: "/assets/icon-png/all-time.png",
      title: "ปรึกษาฟรี! 24 ชั่วโมง",
    },
    {
      id: 4,
      imageUrl: "/assets/icon-png/easy-claim.png",
      title: "เคลมสะดวก ดูแลทุกผลประโยชน์ของคุณ",
    },
  ];
  
  return (
    <div className={style.insurance_ease}>
      <Fragment>
      <DropLeadModal
          isOpen={isOpenDropLeadModal}
          setIsOpen={setIsOpenDropLeadModal}
        />
        <div className={style.insurance_ease_cta_container}>
          <div className={style.title}>
            <h1>ประกันอัคคีภัย TQM Home</h1>
            <h4>
              คุ้มครองบ้านและทรัพย์สินจากเหตุไม่คาดฝัน
              <div className={style.incident_carousel}>
                <Carousel
                  verticalMode
                  showArrows={false}
                  pagination={false}
                  enableAutoPlay={false}
                  preventDefaultTouchmoveEvent={true}
                  itemsToShow={1}
                >
                  <span>ไฟไหม้ อัคคีภัย</span>
                  <span>น้ำท่วม</span>
                  <span>เครื่องใช้ไฟฟ้าช็อต</span>
                </Carousel>
              </div>
            </h4>
          </div>
          <div className={style.ease_items}>
            <ul className={style.ease_items_cointainer}>
              {easeIcons.map((ease) => (
                <li className={style.ease_item} key={ease.id}>
                  <div className={style.ease_icon}>
                    <Image src={ease.imageUrl} layout="fill" objectFit="contain" />
                  </div>
                  <h4>{ease.title}</h4>
                </li>
              ))}
            </ul>
          </div>
          <div className={style.ease_btn_group}>
            <div className={style.ease_main_cta}>
              <Button color="blue" text="คำนวณแผนประกัน" onClick={onClickHandler} />
            </div>
            <div className={style.ease_drop_lead}>
              <Button color="transparent" text="ต้องการคำแนะนำจากพนักงาน" onClick={onDropLeadModalOpenHandler} />
            </div>
          </div>
        </div>
        <div className={style.bear_mascot}>
          <Image src="/assets/images/ease-mascot-graphic.png" layout="fill" objectFit="contain" />
        </div>
      </Fragment>
    </div>
  );
}
